function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons3 = function SvgSurveyIcons3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.81 40.79a2 2 0 0 1-2-2v-7.13a2 2 0 1 1 4 0v7.11a2 2 0 0 1-2 2Z",
    style: {
      fill: "#f05e25",
      opacity: 0.7,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.47 18.12a1.36 1.36 0 0 0-.6.13l-1.42.68a.45.45 0 0 0-.26.58v.19a.4.4 0 0 0 .46.33h.14l.67-.31v6.88a.43.43 0 0 0 .39.46h.46a.42.42 0 0 0 .46-.46v-8c.05-.31-.08-.48-.3-.48Z",
    style: {
      stroke: "#f05e25",
      strokeMiterlimit: 10,
      fill: "#f05e25",
      opacity: 0.7,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 33.67h24.48a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H12a5.63 5.63 0 0 0-5.67 5.64v25.6a5.63 5.63 0 0 0 5.67 5.6h24.48a2 2 0 1 0 0-4H12a1.58 1.58 0 0 1 0-3.16Zm20.73-6.45a2.3 2.3 0 0 1-2.3 2.3H15.77a2.3 2.3 0 0 1-2.3-2.3v-11a.45.45 0 0 1 .45-.45h18.32a.45.45 0 0 1 .45.45ZM13.47 12.49a2.3 2.3 0 0 1 2.3-2.3h1.74V8a.45.45 0 0 1 .42-.45h1.85a.45.45 0 0 1 .45.45v2.21h5.52V8a.45.45 0 0 1 .45-.45h1.85a.45.45 0 0 1 .46.44v2.21h1.84a2.3 2.3 0 0 1 2.3 2.29v1.39a.45.45 0 0 1-.45.45H14a.45.45 0 0 1-.45-.45Z",
    style: {
      fill: "#4f6b80"
    }
  }));
};
export default SvgSurveyIcons3;